import React from 'react';
import ReactDOM from 'react-dom/client';

// M11b "Editorial Apple" type stack:
//   - Geist Sans for body + UI (text-foreground, font-sans, default everything)
//   - Instrument Serif italic for editorial accents (font-serif, hero numerals, page titles)
//   - Inter kept as a safety fallback only — never the primary stack
import '@fontsource/geist-sans/400.css';
import '@fontsource/geist-sans/500.css';
import '@fontsource/geist-sans/600.css';
import '@fontsource/geist-sans/700.css';
import '@fontsource/geist-sans/800.css';
import '@fontsource/geist-sans/900.css';
import '@fontsource/instrument-serif/400.css';
import '@fontsource/instrument-serif/400-italic.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';

import './index.css';
import App from './App';
import { initSentry } from './core/observability/sentry';

initSentry();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
